import React from "react";
import FirstBeauty from "./components/beauty/FirstBeauty";
import SecondBeauty from "./components/beauty/SecondBeauty";
import ThirdBeauty from "./components/beauty/ThirdBeauty";
import FourthBeauty from "./components/beauty/FourBeauty";
import FifthBeauty from "./components/beauty/FifthBeauty";

const Beauty = () => {
  return (
    <>
      <FirstBeauty />
      <SecondBeauty />
      <ThirdBeauty />
      <FourthBeauty />
      <FifthBeauty />
    </>
  );
};

export default Beauty;
